module.exports = __webpack_public_path__ + "img/palettes_jp.8fae92f.jpg";